// src/pages/Register/CompleteRegistrationPage.tsx
import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { completeRegistration } from '../../services/authService';
import LoadingIndicator from '../../components/LoadingIndicator';
import Button from '../../components/Button';
import { setAuthToken } from '../../services/apiClient';
import './CompleteRegistrationPage.css';

const CompleteRegistrationPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const navigate = useNavigate();

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (!token) navigate('/register/email');
  }, [token, navigate]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (password !== confirm) {
      setMessage('パスワードが一致しません。');
      return;
    }
    setLoading(true);
    setMessage('');
    try {
      const res = await completeRegistration({ token, username, password });
      // 成功時に返ってくる access / refresh を保存
      const { access, refresh } = res.data;
      localStorage.setItem('auth_token', access);
      localStorage.setItem('refresh_token', refresh);
      setAuthToken(access);
      window.dataLayer?.push({
        event: 'sign_up',
        method: 'email'
      });
      navigate('/dashboard');
    } catch (err: any) {
      const errMsg =
        err.response?.data?.username?.[0] ||
        err.response?.data?.detail ||
        '登録に失敗しました。';
      setMessage(errMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="complete-registration-page">
      <h1>ユーザー名・パスワード設定</h1>
      {loading && <LoadingIndicator isFullPage={false} />}
      {message && <div className="notification error">{message}</div>}
      <form onSubmit={handleSubmit}>
        <label>ユーザー名</label>
        <input
          type="text"
          required
          placeholder="ユーザー名"
          title="ユーザー名"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />
        <input
          type="password"
          required
          placeholder="パスワード"
          title="パスワード"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <input
          type="password"
          required
          placeholder="パスワード（確認）"
          title="パスワード（確認）"
          value={confirm}
          onChange={(e) => setConfirm(e.target.value)}
        />
        <Button type="submit" disabled={loading}>
          {loading ? '登録中...' : '登録を完了する'}
        </Button>
      </form>
    </div>
  );
};

export default CompleteRegistrationPage;
